var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccuracyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 160,
    viewBox: "0 0 99 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0423 76C73.0839 48.1596 50.8411 25.9167 23.0007 23.9583V21.9535C51.9461 23.9189 75.0818 47.0545 77.0472 76H75.0423ZM-39.0458 76C-37.0804 47.0545 -13.9447 23.9189 15.0007 21.9535V23.9583C-12.8397 25.9167 -35.0825 48.1596 -37.0409 76H-39.0458ZM23.0007 136.042C50.8411 134.083 73.0839 111.84 75.0423 84H77.0472C75.0818 112.945 51.9461 136.081 23.0007 138.046V136.042ZM15.0007 136.042C-12.8397 134.083 -35.0825 111.84 -37.0409 84H-39.0458C-37.0804 112.945 -13.9447 136.081 15.0007 138.046V136.042Z",
    fill: "#26FF7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3639 80H91.7275",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 43.6364L19.0002 7.27272",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 152.727L19.0002 116.364",
    stroke: "#26FF7B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracyMobile);
export default __webpack_public_path__ + "static/media/accuracy-mobile.6bbbe743.svg";
export { ForwardRef as ReactComponent };